import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Set a inquiry's settings visibility
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestSetInquirySettingsVisibility = packet => {
  return {
    type: 'REQUEST_SET_INQUIRY_SETTINGS_VISIBILITY',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveSetInquirySettingsVisibilitySuccess = data => ({
  type: 'RECEIVE_SET_INQUIRY_SETTINGS_VISIBILITY_SUCCESS',
  data
})

export const receiveSetInquirySettingsVisibilityFail = data => ({
  type: 'RECEIVE_SET_INQUIRY_SETTINGS_VISIBILITY_FAIL',
  data
})

export const tryToSetInquirySettingsVisibility = packet => (dispatch, getState) => {

  dispatch(requestSetInquirySettingsVisibility(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/inquiries/settings/visibility/' + packet.id, {
      method: 'put',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveSetInquirySettingsVisibilitySuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveSetInquirySettingsVisibilityFail({errors:e, lastSubmit: packet}));
    })
}
